import { useEffect, useState } from "react";
import { Mail, Briefcase, ShieldCheck, Clock, AtSign } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { MODULES } from "../config/modules";
import ChangePasswordForm from "../auth/ChangePasswordForm";
import { PageHeader, Card, Badge } from "../components/ui";

function Profile() {
  const { user } = useAuth();
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const name = user.fullName || user.username;
  const mine = MODULES.filter((m) => user.modules.includes(m.key));

  return (
    <div className="space-y-6 max-w-4xl">
      <PageHeader title="My Account" subtitle="Your profile, access and password." />

      <div className="grid md:grid-cols-5 gap-5">
        <Card className="md:col-span-3">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-[#C00000] text-white text-xl font-semibold flex items-center justify-center">
              {name.charAt(0).toUpperCase()}
            </div>
            <div>
              <h2 className="text-lg font-semibold text-[#111111]">{name}</h2>
              <Badge tone={user.role === "admin" ? "brand" : "neutral"}>
                {user.role === "admin" ? "Administrator" : "Employee"}
              </Badge>
            </div>
          </div>

          <dl className="mt-6 grid sm:grid-cols-2 gap-4 text-sm">
            <Row icon={<AtSign size={15} />} label="Username" value={user.username} />
            <Row icon={<Mail size={15} />} label="Email" value={user.email || "—"} />
            <Row icon={<Briefcase size={15} />} label="Designation" value={user.designation || "—"} />
            <Row icon={<Clock size={15} />} label="Local time" value={time.toLocaleTimeString()} />
          </dl>
        </Card>

        <Card className="md:col-span-2" title="My access">
          {user.role === "admin" ? (
            <p className="text-sm text-gray-600 flex items-start gap-2">
              <ShieldCheck size={16} className="text-[#C00000] mt-0.5 shrink-0" />
              Administrator: full access to every section and user management.
            </p>
          ) : mine.length === 0 ? (
            <p className="text-sm text-gray-500">No sections enabled yet. Contact your administrator.</p>
          ) : (
            <ul className="space-y-2">
              {mine.map((m) => (
                <li key={m.key} className="flex items-center gap-2 text-sm text-gray-700">
                  <m.icon size={15} className="text-[#C00000]" /> {m.label}
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>

      <Card title="Change password">
        <ChangePasswordForm />
      </Card>
    </div>
  );
}

function Row({ icon, label, value }) {
  return (
    <div>
      <dt className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-gray-500">{icon}{label}</dt>
      <dd className="mt-1 text-[#111111] break-all">{value}</dd>
    </div>
  );
}

export default Profile;
